import Enllac from 'components/corporatiu/Enllac';
import clsx from 'clsx';
import styles from './mostrames.module.scss';

const MostraMes = (props) => {
    const { titol, link, linkTipus, slug, estil, tema } = props;
    let text = titol;

    const route = {
        href: link,
        type: linkTipus,
        slug: slug
    };

    const styleMostraMes = clsx({
        [styles.mostraMes]: true,
        [styles[estil]]: !!estil,
        [styles[tema]]: !!tema
    });

    if (link || linkTipus) {
        return (
            <div className={styleMostraMes}>
                <Enllac route={route} className={styles.mostraMes_btn} ariaLabel={text} title={text}>
                    {text}
                </Enllac>
            </div>
        );
    } else {
        return <></>;
    }
};

export default MostraMes;
